/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FeatureFlag {
    FEATURE_YOY_MIGRATION_ENABLED = 'feature_yoy_migration_enabled',
    FEATURE_PRICING_POLICY_ENABLED = 'feature_pricing_policy_enabled',
    QUICKSIGHT_AUTHORING_ENABLED = 'quicksight_authoring_enabled',
    DATA_MANAGEMENT = 'data_management',
    DATA_MANAGEMENT_V2 = 'data_management_v2',
    NEW_RECOMMENDATION_MODE = 'new_recommendation_mode',
    JOB_RECOMMENDATIONS_AI = 'job_recommendations_ai',
    SURVEY_REPLACEMENT_WIZARD = 'survey_replacement_wizard',
    SURVEY_ORCHESTRATION_CUSTOMER_EXPERIENCE = 'survey_orchestration_customer_experience',
    SIMPLIFIED_RANGE_ELIGIBILITY_ENABLED = 'simplified_range_eligibility_enabled',
    SURVEY_ORCHESTRATION_CUSTOMER_SURVEY_DOWNLOAD = 'survey_orchestration_customer_survey_download',
    LEVEL_MAPPING_GLOBAL_GRADES_TO_GLOBAL_LEVEL = 'level_mapping_global_grades_to_global_level',
    USAGE_STATISTICS_FOR_SURVEY_JOBS_AND_DATA_CUTS = 'usage_statistics_for_survey_jobs_and_data_cuts',
    TENANCY_MANAGEMENT = 'tenancy_management',
    SPLITTED_SURVEYS_AND_PARTICIPATIONS = 'splitted_surveys_and_participations',
    JOB_DESCRIPTION_EDITING = 'job_description_editing',
}
